import React, { useEffect, useState } from 'react';
import { fetchLoginImage } from 'assets/js/common';
import LoginForm from 'components/authentication/loginForm';
import AuthSplitLayout from 'layouts/authSplitLayout';
import Flex from 'components/common/flex';
import LanguageButtons from 'components/navbar/top/languageBtn';
import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const { t } = useTranslation();
  const [loginBgImage, setLoginBgImage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [hideHeader, setHideHeader] = useState(false); 

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    const token = localStorage.getItem("token");

    if (isLoggedIn && token) {
      const isMedewerker = localStorage.getItem("isMedewerker") === "true";
      navigate(isMedewerker ? "/employee/dashboard" : "/dashboard", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    const loadImage = async () => {
      const domainToUse = process.env.REACT_APP_DEFAULT_DOMAIN;
      const cacheKey = `cachedLoginBg_${domainToUse}`;

      const cached = localStorage.getItem(cacheKey);
      if (cached) {
        setLoginBgImage(cached);
        setIsLoading(false);
        return;
      }

      const image = await fetchLoginImage();
      localStorage.setItem(cacheKey, image);
      setLoginBgImage(image);
      setIsLoading(false);
    };

    loadImage();
  }, []);

  if (isLoading) {
    return (
      <div className="text-center my-5">
       <Spinner animation="border" role="status">
          <span className="visually-hidden">{t("loading")}</span>
        </Spinner>
      </div>
    );
  }

  return (
    <>
      <div className="language-buttons">
        <LanguageButtons />
      </div>
      <AuthSplitLayout bgProps={{ image: loginBgImage, position: '50% 20%' }}>
        {!hideHeader && (
                  <Flex alignItems="center" justifyContent="center">
                    <div className="text-center mb-2">
                      <h3 className="fw-bold text-800 mb-1">{t("Welcomeback")}</h3>
                      <p className="small fs-10 opacity-75">
                        {t("loginToYour")} {process.env.REACT_APP_ORGANIZATION_NAME} {t("account")}
                      </p>
                    </div>
                  </Flex>
          )}
        <LoginForm 
          layout="split" 
          hasLabel 
          onCodeSent={(val) => setHideHeader(val)} 
        />
      </AuthSplitLayout>
    </>
  );
};

export default Login;
